import { Row, Col } from "react-bootstrap";
import { FaSearch } from "react-icons/fa";
import GradientButton from "./Button/GradientButton";
import { useContext, useEffect, useState } from "react";
import "./Header.css";
import RootContext from "../context/RootContext";
import { NavLink } from "react-router-dom";
import api from "../services/api";
import { useRef } from "react";
// import { ChevronDownIcon } from "./Icons/icons";

const Header = () => {
  const navRef = useRef(null);

  const { language, setLanguage } = useContext(RootContext);

  const [query, setQuery] = useState("");
  const [results, setResults] = useState([]);

  const [mobileMegaOpen, setMobileMegaOpen] = useState(false);

  const [menuOpen, setMenuOpen] = useState(false);

  /* ===============================
     FETCH CATEGORY LIST (ONCE)
  ================================ */
  useEffect(() => {
 
       const nav = navRef.current;
       const navOffsetTop = nav.offsetTop;

      const handleScroll = () => {
        if (window.scrollY >= navOffsetTop) {
          nav.classList.add("is-fixed");
        } else {
          nav.classList.remove("is-fixed");
        }
      };

      window.addEventListener("scroll", handleScroll);
      return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  /* ===============================
     SEARCH FUNCTION
  ================================ */
  const handleSearch = async (searchText, categoryId) => {
    if (!searchText) {
      setResults([]);
      return;
    }

    try {
      const res = await api.get("search-products", {
        params: {
          query: searchText,
          category: categoryId,
        },
      });
      setResults(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  /* ===============================
     DEBOUNCE SEARCH
  ================================ */
  useEffect(() => {
    const delay = setTimeout(() => {
      handleSearch(query);
    }, 500);

    return () => clearTimeout(delay);
  }, [query]);

  /* ===============================
     LANGUAGE SWITCH
  ================================ */
  const handleLanguageChange = (lang) => {
    setLanguage(lang);
    localStorage.setItem("language", lang);
  };
  /* ===============================
     CLOSE MOBILE MEGA MENU
  ================================ */
  const closeMobileMega = () => {
    setMobileMegaOpen(false);
  };

useEffect(() => {
  const handleScroll = () => {
    setMenuOpen(false);
    setMobileMegaOpen(false);
  };

  window.addEventListener("scroll", handleScroll, { passive: true });

  return () => {
    window.removeEventListener("scroll", handleScroll);
  };
}, []);



  return (
    <header className="bg-white shadow shadow-sm py-2">
      <Row className="align-items-center m-0">
        {/* LOGO */}
        <Col md={3} className="d-flex align-items-center ps-3">
          <NavLink to="/" className="d-flex align-items-center text-decoration-none">
            <img
              src="/asset/img/logo/logo.webp"
              alt="Lungi Sari Logo"
              width="40"
              height="40"
              className="me-2 shadow-sm border border-light cursor-pointer"
            />
            <div>
              <h1 className="mb-0 fw-bold text-dark" style={{fontSize: "22px"}} data-no-translate>
                Lungi Sari
              </h1>
              <h6 className="text-muted" style={{fontSize: "15px"}}>Your Smart Shopping Partner</h6>
            </div>
          </NavLink>
        </Col>

        {/* SEARCH */}
        <Col md={6}>
          <div className="search-wrapper position-relative">
            <div className="border input-group rounded-pill overflow-hidden">
              <span className="input-group-text bg-white border-0">
                <FaSearch />
              </span>

              <input
                type="text"
                placeholder="Search Products..."
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                className="form-control"
              />

          
            </div>

            {/* SEARCH DROPDOWN */}
            {results.length > 0 && (
              <div className="search-dropdown shadow-sm">
                {results.slice(0, 6).map((item) => (
                  <NavLink
                    key={item.id}
                    to={`/product-details/${item.slug_to_product}`}
                    className="search-item text-decoration-none"
                    onClick={() => {
                      setResults([]);
                      setQuery("");          // 👈 input clear হবে
                  }}
>

                    <div className="search-item-content">
                      <img src={ process.env.REACT_APP_IMAGEBASE_URL + "products/" +  item.image_file_name}
                        alt={item.product_name}
                        className="search-item-img"
                      />

                      <div className="search-item-info">
                        <div className="search-item-name">
                          {item.product_name}
                        </div>

                        <div className="search-item-price">
                          <span className="price">
                            TK.{item.product_unit_price}
                          </span>
                          {item.product_regular_price && (
                            <span className="old-price">
                              TK.{item.product_regular_price}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                  </NavLink>
                ))}
              </div>
            )}
          </div>
        </Col>

        {/* LANGUAGE + BUTTON */}
        <Col md={3}>
          <div className="d-flex justify-content-between align-items-center">
            <div
              className="border border-info language-toggle rounded-pill d-flex"
              data-no-translate
            >
              <button
                className={`btn ${
                  language === "en" ? "active" : "inactive"
                } rounded-pill`}
                onClick={() => handleLanguageChange("en")}
              >
                <small>ENG</small>
              </button>
              <button
                className={`btn ${
                  language === "bn" ? "active" : "inactive"
                } rounded-pill`}
                onClick={() => handleLanguageChange("bn")}
              >
                <small>বাংলা</small>
              </button>
            </div>

            <GradientButton buttonText="Track Order" to="/order-tracking" />
          </div>
        </Col>
      </Row>
        {/* Mega Menu Design */}

        {/* portion shodo sticky hobe scroll korle oita top e thakbe  */}
      <nav className="navbar navbar-expand-lg navbar-light bg-white border-top sticky-menu-top p-0"  ref={navRef}>
        <div className="container">
          <NavLink className="navbar-brand fw-bold" to="/">
             <img
              src="/asset/img/logo/logo.webp"
              alt="Lungi Sari Logo"
              width="40"
              height="40"
              className="me-2 shadow-sm border border-light cursor-pointer sticky-logo"
            />
          </NavLink>

          <button
            className="navbar-toggler"
            type="button"
            onClick={() => setMenuOpen(!menuOpen)}
          >
            {menuOpen ? (
              <span style={{ fontSize: "24px", fontWeight: "bold" }}>✖</span>
            ) : (
              <span className="navbar-toggler-icon"></span>
            )}
          </button>

          <div className="collapse navbar-collapse" id="navMenu" style={{ display: menuOpen ? "block" : "none" }}>
            <ul className="navbar-nav mx-auto">

              <li className="nav-item">
                <NavLink className="nav-link" to="/" onClick={closeMobileMega}>Home</NavLink>
              </li>

              <li className="nav-item">
                <NavLink className="nav-link" to="/all-products" onClick={closeMobileMega}>
                  All Products
                </NavLink>
              </li>

              {/* PURE CSS MEGA MENU */}
               <li
                  className={`nav-item mega-dropdown ${
                    mobileMegaOpen ? "mobile-open" : ""
                  }`}
                >
                <button
                  className="nav-link mega-toggle"
                  onClick={() => {
                    if (window.innerWidth <= 991) {
                      setMobileMegaOpen(!mobileMegaOpen);
                    }
                  }}
                >
                  {/* <span>Shop </span>
                  <ChevronDownIcon /> */}

                  <span
                    className={`chevron-icon ${
                      mobileMegaOpen ? "rotate" : ""
                    }`}
                  >
                    
                  </span>
                </button>

                {/* <div className="mega-menu">
                  <div className="mega-inner">

                
                    <div className="mega-column">
                      <h4 className="mega-title">Jamdani</h4>
                      <NavLink className="nav-link" to="#">Embroidery</NavLink>
                      <NavLink className="nav-link" to="#">Block Print</NavLink>
                      <NavLink className="nav-link" to="#">Natural Dye</NavLink>
                    </div>

                 
                    <div className="mega-column">
                      <h4 className="mega-title">Fabric</h4>
                        <NavLink className="nav-link" to="#">Embroidery</NavLink>
                        <NavLink className="nav-link" to="#">Block Print</NavLink>
                        <NavLink className="nav-link" to="#">Natural Dye</NavLink>
                    </div>

              
                    <div className="mega-column">
                      <h4 className="mega-title">Craft</h4>
                      <NavLink className="nav-link" to="#">Embroidery</NavLink>
                      <NavLink className="nav-link" to="#">Block Print</NavLink>
                      <NavLink className="nav-link" to="#">Natural Dye</NavLink>
                    </div>

            
                    <div className="mega-promo">
                      <img src="/asset/img/logo/logo.webp" alt="promo" />
                      <p>Discover premium handcrafted collections</p>
                    </div>

                  </div>
                </div> */}
              </li>

              <li className="nav-item">
                <NavLink className="nav-link" to="/contact" onClick={closeMobileMega}>
                  Contact
                </NavLink>
              </li>

            </ul>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Header;
